module.exports = __webpack_public_path__ + "img/login_bg.7f544f4a.jpg";